/**
* @Description: apply
* @author XuZiYu
* @date 2021-07-19 15:03
*/
<template>
  <div class="wrapper">
    <ctl-header :title="'申请信息详情'"></ctl-header>
    <div class="status">
      <img class="status-icon" v-if="form.ensureStatus === 1" src="@/assets/vip/icon_shz.png" alt="">
      <img class="status-icon" v-if="form.ensureStatus === 3 || form.ensureStatus === 4" src="@/assets/vip/icon_shcg.png" alt="">
      <img class="status-icon" v-if="form.ensureStatus === 2 || form.ensureStatus === 5" src="@/assets/vip/icon_shsb.png" alt="">
      {{form.ensureStatusStr}}
    </div>
    <van-cell-group class="main">
      <van-field
        readonly
        input-align="right"
        v-model="form.subject"
        label="补偿科目"
      >
      </van-field>
      <van-field
        readonly
        input-align="right"
        v-model="form.examCityCode"
        label="考试所在城市"
      >
      </van-field>
      <van-field
        input-align="right"
        v-model="form.stuName"
        label="学员姓名"
        readonly
      >
      </van-field>
      <van-field
        input-align="right"
        label="证件号"
        readonly
      >
        <div slot="input">
          {{form.stuIdcard | coding([3,14,1])}}
        </div>
      </van-field>
      <div class="cell-title">
        收款账号
      </div>
      <van-field
        @click="collectTypeShow = true"
        size="large"
        input-align="right"
        v-model="form.collectTypeName"
        readonly
        label="收款方式"
      >
        <div v-if="form.collectType === 5" class="yhk-value " slot="input">银行卡</div>
        <div v-if="form.collectType === 2" class="zfb-value" slot="input">支付宝</div>
      </van-field>
      <template v-if="form.collectType === 2">
        <van-field
          rows="1"
          autosize
          type="textarea"
          input-align="right"
          v-model="form.alibNo"
          label="支付宝账号"
          readonly
          clearable
        >
        </van-field>
        <van-field
          rows="1"
          autosize
          type="textarea"
          input-align="right"
          v-model="form.alibName"
          label="支付宝实名"
          readonly
          clearable
        >
        </van-field>
      </template>
      <template v-if="form.collectType === 5">
        <van-field
          input-align="right"
          v-model="form.bankcardNo"
          label="银行卡号"
          placeholder="请输入本人银行卡号"
          clearable
          readonly
        >
        </van-field>
        <van-field
          input-align="right"
          v-model="form.bankName"
          label="开户行"
          clearable
          readonly
        >
        </van-field>
      </template>
    </van-cell-group>
    <van-cell-group>
      <div class="cell-title">
        考试成绩资料
      </div>
      <van-field
        input-align="right"
        v-model="form.examSysPwd"
        label="122登录密码"
        clearable
      >
      </van-field>
      <van-field name="uploader" label="成绩单" input-align="right" class="label-uploader">
        <template #input>
          <div id="uploader">
            <img @click="showBig" v-if="form.examSysUrl" class="uploader-icon" :src="form.examSysUrl" alt="">
          </div>
        </template>
      </van-field>
    </van-cell-group>

    <template v-if="form.remark">
      <div class="cell-title">
        备注说明
      </div>
      <div class="remark">{{form.remark}}</div>
    </template>
  </div>
</template>

<script>
import { Field, CellGroup, Toast, ImagePreview } from 'vant'
export default {
    name: 'applyDetail',
    components: {
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [Toast.name]: Toast
    },
    data () {
        return {
            loading: false,
            isSubmit: false,
            form: {
                subject: '',
                vipUserId: '',
                collectTypeName: '',
                collectType: '',
                bankcardNo: '',
                compensateId: '',
                bankName: '',
                alibNo: '',
                alibName: '',
                examSysPwd: '',
                examSysUrl: '',
                imgUrl: ''
            }
        }
    },
    filters: {
        coding (v, rule) {
            if (!v) {
                return
            }
            let firstString = v.substring(0, rule[0])
            let secondString = ''
            let threeString = v.substring(v.length - rule[2], v.length)
            for (let n = 0; n < rule[1]; n++) {
                secondString += '*'
            }
            return `${firstString}${secondString}${threeString}`
        }
    },
    watch: {
        form: {
            handler () {
                // 判断支付方式
                if (this.form.collectType === '2') {
                    this.isSubmit = !!this.form.collectType && !!this.form.alibNo && !!this.form.alibName && !!this.form.examSysPwd
                } else {
                    this.isSubmit = !!this.form.collectType && !!this.form.bankcardNo && !!this.form.bankName && !!this.form.examSysPwd
                }
            },
            deep: true
        }
    },
    methods: {
        // 获取信息
        getInfo () {
            this.$api.compensateDetail({ compensateId: this.form.compensateId }).then(res => {
                if (res.status) {
                    this.form = res.result || {}
                }
            })
        },
        // 返回
        goBack () {
            this.$router.back()
        },
        showBig () {
            ImagePreview([this.form.examSysUrl])
        }
    },
    created () {
        this.form.compensateId = this.$route.query.compensateId

        this.getInfo()
    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
  .wrapper {
    background-color: #fafafa;
    overflow: hidden;
  }

  /deep/ {
    .van-cell-group::after {
      border-width: 0;
    }

    .van-cell {
      padding: 20px 15px;
    }

    .van-field__label {
      font-size: 15px;
      font-weight: 400;
      color: #333333;
    }

    .van-field__control::placeholder {
      font-size: 15px;
      font-weight: 400;
      color: #999999;
    }

    .van-field__control {
      font-size: 15px;
      font-weight: 400;
      color: #333333;
    }

    .icon-clear {
      width: 18px;
      height: 18px;
    }

    .van-field__body {
      display: flex;
      align-items: center;
    }

    .van-field__right-icon {
      display: flex;
      align-items: center;
    }

    .van-cell:nth-child(4)::after {
      display: none;
    }

    .van-action-sheet__content {
      padding: 0 15px 50px;
    }

    .van-action-sheet__header {
      padding: 20px 0;
      line-height: 1;
      font-size: 18px;
      font-weight: 600;
      color: #333333;

      .van-icon {
        top: 17px;
      }
    }
    .label-uploader{
      padding: 10px 15px;

      .van-cell__title{
        display: flex;
        align-items: center;
      }
    }
  }

  .cell-title {
    background-color: #fafafa;
    padding: 15px 15px 10px;
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
    color: #333333;
  }

  .van-button {
    width: 345px;
    height: 43px;
    margin: 15px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.3rem;
    opacity: 1;
    border: 0;
    line-height: 1;
    border-radius: 21px;
    background-color: #53CB85;

    .van-button__text {
      font-size: 17px;
      font-weight: 400;
      color: #FFFFFF;
    }
  }

  .disabled {
    background: #CCCCCC;
  }

  .rule {
    padding: 10px 15px 0;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    background-color: #fafafa;
  }

  .zfb-icon {
    padding: 24px 0;
    border-bottom: 1px solid #eee;

    /deep/ .van-action-sheet__name {
      padding-left: 34px;
      background: url('~@/assets/vip/icon_zfb.png') no-repeat;
      background-size: 24px;
    }
  }

  .zfb-value {
    padding-left: 24px;
    background: url('~@/assets/vip/icon_zfb.png') no-repeat center left;
    background-size: 18px;
  }

  .yhk-icon {
    padding: 24px 0;

    /deep/ .van-action-sheet__name {
      padding-left: 34px;
      background: url('~@/assets/vip/icon_yhk.png') no-repeat;
      background-size: 24px;
    }
  }

  .yhk-value {
    padding-left: 24px;
    background: url('~@/assets/vip/icon_yhk.png') no-repeat center left;
    background-size: 18px;
  }

  .uploader-icon{
    display: block;
    width: 80px;
    height: 80px;
    object-fit: cover;
  }

  #uploader{
    position: relative;

    .uploader-input{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      cursor: pointer;
      opacity: 0;
    }
  }

  .remark{
    background-color: #fff;
    word-break: break-word;
    padding: 20px 15px;
    font-size: 15px;
    font-weight: 400;
    color: #FF5050;
  }

  .status{
    padding-bottom: 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    font-size: 21px;
    font-weight: 400;
    color: #333333;

    .status-icon{
      margin-bottom: 10px;
      width: 100px;
    }
  }
</style>
